// Convierte URLs de medios que apuntan al propio sitio en rutas relativas.
//
// En el admin se llegaron a pegar direcciones copiadas del navegador local
// (http://localhost:3000/images/...). En producción esas imágenes se rompían y
// Chrome mostraba el aviso "quiere acceder a otros servicios y apps en este
// dispositivo" (Local Network Access). Con esto, "http://localhost:3000/x.webp"
// y "https://www.physiologyskincare.com/x.webp" quedan como "/x.webp".
const SELF_ORIGIN = /^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0|(www\.)?physiologyskincare\.com)(:\d+)?(?=\/)/i;

export function toSitePath(url) {
  return typeof url === 'string' ? url.trim().replace(SELF_ORIGIN, '') : url;
}

// Aplica toSitePath a todos los valores de texto de un objeto (un nivel).
export function sitePathsIn(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const out = Array.isArray(obj) ? [...obj] : { ...obj };
  for (const k of Object.keys(out)) {
    if (typeof out[k] === 'string') out[k] = toSitePath(out[k]);
  }
  return out;
}
